// extracted by mini-css-extract-plugin
export var animateEnter = "index-module--animate-enter--cx61z";
export var animateEnterFrames = "index-module--animate-enter-frames--AbPMw";
export var banner = "index-module--banner--NzBoJ";
export var gatsbyImageWrapper = "index-module--gatsby-image-wrapper--AzhIi";
export var imgholder = "index-module--imgholder--tSETq";
export var mobileimageholder = "index-module--mobileimageholder--nudgk";
export var runawaylittlegirl = "index-module--runawaylittlegirl--SFA2n";
export var runner = "index-module--runner--jYGwF";
export var running = "index-module--running--DMtTn";